export default {
	head: {
		title: 'Blumar - Online Reservation',
		description: '',
		keywords: 'Blumar Online Reservation',
		ogDescription: '',
	},
	navbar: {
		makeBookings: "Make Your Bookings",
		seeBookings: "See Your Bookings",
		exit: 'Logout',
		cart: 'My Cart'
	},
	loginArea: {
		user: 'Login',
		pass: 'Password',
		enter: 'Sign In',
		errorMsg: 'Login or password invalid!'
	},
	searchArea: {
		destination: 'City or Hotel Name',
		checkin: 'Checkin',
		checkout: 'Checkout',
		rooms: 'Rooms',
		adults: 'Adults',
		children: 'Children',
		age: 'Age',
		search: 'Search',

		destinationNotFound: 'Destination not found.',
		resultNotFound: 'No results found.',
		invalidFields: 'Fill in the field(s): ',

		hotel: 'Hotel',
		city: 'City',
		specialDestination: 'Special Destination',
		more: 'More About',
		book: 'Booking',

		sortBy: 'ORDER BY',
		hotelNameUpperCase: 'HOTEL NAME',
		starsUpperCase: 'STARS',
		priceUpperCase: 'PRICE',

		resultsText: (total, pages) => `Were found ${total} hotels in ${pages} pages.`,
		pagination: {
			first: 'First',
			prev: 'Prev',
			next: 'Next',
			last: 'Last',
		},

		filters: 'FILTER BY',
		hotelName: 'Hotel Name',
		stars: 'Stars',
		price: 'Price',
		district: 'District',
		clearButton: 'Clear',

		hotelFacilities: 'Hotel Facilities',
		hotelLocation: 'Hotel Location',
		roomsFacilities: 'Rooms Facilities',

		mealPlans: {
			noMeals: 'No Meals',
			Breakfast: 'Breakfast Incl',
			Map: 'Half Board Incl',
			Fap: 'Full Board Incl',
			AllInclusive: 'All Inclusive'
		},

		confirmation: {
			bookingDetails: 'Booking Details',
			meal: 'Meal',
			roomCategory: 'Room Category',
			room: 'Room',
			taxObs: 'All mandatory taxes included',
			cancellationPolicy: 'Cancellation Policy',
			clientInformation: 'Client Information',
			guest: 'Guest',
			information: (total) => `Room ${total} Information`,
			observations: 'Observations',
			name: 'Name',
			generalConditions: 'General Conditions',
			invoiceAdvice: 'This reservation will be invoiced to your company',
			generalConditionsText1: 'I Accept all',
			cancellationPolicyText1: 'I Accept the',
			finalize: 'Finalize',
			errorMsg: 'Error when making the booking! Contact our operators!',
			generalConditionsDescription: `
				TAXES<br>
				* All taxes are included, except city room tax or environmental tax that are not included<br>
				* City Room Tax should be paid directly by guests upon checkout, unless requested upon booking. Room tax is only
				charged at some Brazilian hotels - tax varies between US$3,00 and US$7,00 per room, per night. This tax is not
				mandatory and the guest can ask for it to be excluded from the bill at the hotel.
				<br><br>

				MEAL PLANS<br>
				* Meals at hotels do not include drinks unless otherwise stated.<br>
				* Rates for half board and full board pension are not valid for December 24 and 31.
				<br><br>

				TIME FOR CHECK IN/CHECK OUT OF HOTELS IN BRAZIL<br>
				The majority of hotels have a fixed check in at 3:00pm and check out at 12:00 pm, but there are exceptions. If
				your passenger needs an earlier check in or later check out, it is recommended to add one more night.
				<br><br>

				ACCOMMODATION IN TRIPLE ROOM (capacity for three people):<br>
				In Brazil, the majority of hotels offer apartments composed of a double bed and an extra cot-bed. This
				accommodation is recommended for families. Other options are available, but not guaranteed. Consult upon booking
				the different types of accommodations available.
				<br><br>

				OFFICE HOURS<br>
				* The office is open from Monday to Friday from 08:00am to 07:00pm, after this time any urgent request or
				cancellation must be also informed by phone, through our Emergency phone number , in addition to a written
				request.
				<br><br>

				EMERGENCY ASSISTANCE<br>
				* The emergency phone number is at the disposal of your clients. Available 24 hrs/day, 7 days/week.<br>
				General emergency phone: (21) 99630 4627 <br>
				If you are calling from abroad you must dial: 55 (21) 99630 4627 <br>
				If you are calling from Brazil but outside Rio (021 21 ) 99630 4627 <br>
				If you are calling from Rio de Janeiro city you just dial the local number: 99630 4627 <br>`
		}
	},

	seeBookings: {
		initialDate: 'Initial Date',
		finalDate: 'Final Date',
		initialCheckin: 'Initial Checkin',
		finalCheckin: 'Final Checkin',
		reset: 'Reset',
		search: 'Search',
		resultsText: (total, pages) => `Were found ${total} hotels in ${pages} pages.`,

		date: 'Date',
		checkin: 'Checkin',
		price: 'Price',
		actions: 'Actions',

		seeYourBooking: 'See your booking',
		voucher: 'Voucher',
		invoice:'Invoice',
		cancel: 'Cancel',

		documentErrorMsg: 'Error loading document!',
		cancelConfirmationText: (fileNumber) => `Do you want to cancel the booking ${fileNumber}?`,
		cancelSuccessMsg: (fileNumber) => `Booking ${fileNumber} successfully canceled!`,
		cancelFailMsg: 'Error canceling booking! Contact the Blumar operator!',
	}
}



// WEBPACK FOOTER //
// ./src/assets/translationEn.js